"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitDependencies = void 0;
const types_1 = require("./types");
const getInitDependencies = (dependencyConfigBase, baseDependenciesInstance) => (dependencyConfigOverrides) => {
    types_1.dependencyTypes.forEach(type => {
        var _a;
        baseDependenciesInstance[type] = Object.freeze(Object.assign(Object.assign({}, dependencyConfigBase[type]()), (_a = dependencyConfigOverrides === null || dependencyConfigOverrides === void 0 ? void 0 : dependencyConfigOverrides[type]) === null || _a === void 0 ? void 0 : _a.call(dependencyConfigOverrides)));
    });
    return Object.freeze(baseDependenciesInstance);
};
exports.getInitDependencies = getInitDependencies;
//# sourceMappingURL=getInitDependencies.js.map